import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import {
  AccessManagementBaseAuthService,
  AccessManagementUserAuthContext,
} from '@cdw-ae/access-management-common-services';
import { firstValueFrom, Subject } from 'rxjs';
import { ApiUrlBuilderService } from '../../../../../common/services/api-url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class AccessManagementFrontendAuthService
  extends AccessManagementBaseAuthService
  implements OnDestroy
{
  public refreshDialogOpen = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private httpClient: HttpClient,
    private readonly urlBuilder: ApiUrlBuilderService
  ) {
    super();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public async setUserAuthContext(): Promise<void> {
    const httpResult: AccessManagementUserAuthContext =
      await this.loadEffectivePermissions();
    const jsonString: string = httpResult.permissions as unknown as string;
    const parsedData: [string, string[]][] = JSON.parse(jsonString);
    const retrievedMap: Map<string, Set<string>> = new Map(
      parsedData.map(
        ([key, value]: [string, string[]]): [string, Set<string>] => [
          key,
          new Set(value),
        ]
      )
    );

    this.authContext = { ...httpResult, permissions: retrievedMap };
  }

  public loadEffectivePermissions(): Promise<AccessManagementUserAuthContext> {
    return firstValueFrom(
      this.httpClient.get(
        this.urlBuilder.backendApi('auth', 'getUserAuthContext')
      )
    ) as Promise<AccessManagementUserAuthContext>;
  }
}
